<template>
  <div>
    <div class="row">
      <h2 class="col-12 col-md-6">Lista Cantieri</h2>
      <div class="col-12 col-md-6 text-md-right">
    		<router-link to="/sites/create">
    			<base-button type="primary">
            <i class="tim-icons icon-simple-add"></i>
    				Crea nuovo
    			</base-button>
    		</router-link>
      </div>
    </div>
    <card class="responsive-card-table">
      <sites-table></sites-table>
    </card>
  </div>
</template>
<script>
import SitesTable from '@/components/Sites/SitesTable.vue';

export default{
  computed: {
  },
  components: {
    SitesTable
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
}	
</script>